module.exports = __webpack_public_path__ + "img/background_login.095dc645.svg";